import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, ResponseHttpSuccess, UtilService} from "library";
import {environment} from "projects/store/src/environments/environment";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {SalesWorkflow, SalesWorkflowSteps, TrafficSource} from "projects/store/src/app/enums/index";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import { StoreV3Service } from '../../../services/api/v1/store-v3.service';
import {PathNavigationService} from "projects/store/src/app/services/api/v1/path-navigation.service";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {from, switchMap} from "rxjs";
import {NotificationOtpService} from "projects/store/src/app/services/api/v1/notification-otp.service";

@Component({
  selector: 'app-sales-final-instructions-client',
  templateUrl: './sales-final-instructions-client.component.html'
})
export class SalesFinalInstructionsClientComponent implements OnInit {

  protected store: any;
  protected requestId: any;
  protected flowCode: any;
  protected request: any; // Acceso global al store
  protected storeV3: any; // Acceso global al storeV3
  protected readonly environment = environment;
  protected readonly TrafficSource = TrafficSource;
  protected currency: string = environment.global.country.currency;
  showQr: boolean = false;

  @Output() gotoStepEvent = new EventEmitter<{ flowCode: string; stepCode: string; categoryCode?: string; requestId?: string }>();

  constructor(
    protected requestService: RequestService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected utilService: UtilService,
    protected customMessageService: CustomMessageService,
    protected salesWorkflowService: SalesWorkflowService,
    private storeService: StoreV3Service,
    private pathNavigationService: PathNavigationService,
    protected notificationOtpService: NotificationOtpService
  ) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.request = this.requestService.request;
    this.storeV3 = this.storeService.store;
  }

  ngOnInit() {
    this.load();
  }

  protected load() {
    this.utilService.disablePageLoading();
  }

  protected getCanCancelRequest(): boolean {
    return this.salesWorkflowService.canCancelRequest();
  }

  protected get isFlowkrdya() {
    return this.flowCode === SalesWorkflow['app-krdya-cliente'];
  }

  onBackToKrdya(): void {
    this.pathNavigationService.navigateToExitAppKrdya();
  }

  onBackToStoresList(){
    this.gotoStepEvent.emit({
      flowCode: SalesWorkflow['app-krdya-cliente'],
      stepCode: SalesWorkflowSteps['store-view-by-category'],
      categoryCode: this.route.snapshot.params['category_code'],
      requestId: this.requestId,
    });
  }

  onChangeURL(base64Code: any) {
    const blobUrl: string = base64Code?.changingThisBreaksApplicationSecurity || base64Code;
    const phone = this.request.person.phone;
    from(fetch(blobUrl).then(r => r.blob())).pipe(
      switchMap((blob: Blob) => this.notificationOtpService.uploadFormData(blob, 'qr-code.png', 'qrcode')),
      switchMap((resp: any) => {
        const url = resp.body.url;
        return this.notificationOtpService.sendWhatsapp(phone, url);
      })
    ).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        this.showQr = true;
        if (resp.status !== HttpStatusCode.NoContent) {
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.showQr = true;
        this.customMessageService.responseNoticeHandler(err);
      }
    });
  }
}
